import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const projectTagsApi = createApi({
  reducerPath: 'projectTagsTypesApi',
  baseQuery: rtkBaseQuery('/ticket/Project'),
  tagTypes: ['ProjectTag', 'ProjectTypes', 'FinancingTypeProject'],
  endpoints: (builder) => ({
    getAllProjectTag: builder.query({
      query: () => '/GetTags',
      providesTags: ['ProjectTag'],
    }),
    createProjectTag: builder.mutation({
      query: ({ name }) => ({
        url: '/CreateTag',
        method: 'POST',
        responseHandler: (response) => response.text(),
        params: { name },
      }),
      invalidatesTags: ['ProjectTag'],
    }),
    updateProjectTag: builder.mutation({
      query: ({ id, name }) => ({
        url: `/EditTag?id=${id}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
        params: { id, name },
      }),
      invalidatesTags: ['ProjectTag'],
    }),
    deleteProjectTag: builder.mutation({
      query: (id) => ({
        url: `/RemoveTag?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['ProjectTag'],
    }),
    getAllProjectTypes: builder.query({
      query: () => '/GetProjectTypes',
      providesTags: ['ProjectTypes'],
    }),
    getProjectTypeById: builder.query({
      query: ({ id }) => `/GetProjectTypeById?id=${id}`,
    }),
    createProjectType: builder.mutation({
      query: ({ nameUz, nameRu }) => ({
        url: `/CreateProjectType`,
        method: 'POST',
        params: { nameUz, nameRu },
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['ProjectTypes'],
    }),

    updateProjectType: builder.mutation({
      query: ({ id, nameUz, nameRu }) => ({
        url: `/EditProjectType`,
        method: 'PUT',
        params: { nameUz, nameRu, Id: id },
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['ProjectTypes'],
    }),
    deleteProjectType: builder.mutation({
      query: (id) => ({
        url: `/DeleteProjectType?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['ProjectTypes'],
    }),
    getAllFinancingType: builder.query({
      query: () => '/GetFinancingTypeProjects',
      providesTags: ['FinancingTypeProject'],
    }),
    createFinancingType: builder.mutation({
      query: ({ nameUz, nameRu }) => ({
        url: '/CreateFinancingTypeProject',
        method: 'POST',
        responseHandler: (response) => response.text(),
        params: { nameUz, nameRu },
      }),
      invalidatesTags: ['FinancingTypeProject'],
    }),
    updateFinancingType: builder.mutation({
      query: ({ id, nameUz, nameRu }) => ({
        url: `/EditFinancingTypeProject?id=${id}`,
        method: 'PUT',
        responseHandler: (response) => response.text(),
        params: { id, nameUz, nameRu },
      }),
      invalidatesTags: ['FinancingTypeProject'],
    }),
    deleteFinancingType: builder.mutation({
      query: (id) => ({
        url: `/DeleteFinancingTypeProject?id=${id}`,
        method: 'DELETE',
        responseHandler: (response) => response.text(),
      }),
      invalidatesTags: ['FinancingTypeProject'],
    }),
  }),
});

export const {
  useGetAllProjectTagQuery,
  useCreateProjectTagMutation,
  useUpdateProjectTagMutation,
  useDeleteProjectTagMutation,
  useGetAllProjectTypesQuery,
  useGetProjectTypeByIdQuery,
  useCreateProjectTypeMutation,
  useUpdateProjectTypeMutation,
  useDeleteProjectTypeMutation,
  useGetAllFinancingTypeQuery,
  useCreateFinancingTypeMutation,
  useUpdateFinancingTypeMutation,
  useDeleteFinancingTypeMutation,
} = projectTagsApi;
